import React from 'react';
import styled from 'styled-components';
import {Dialog, Item} from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Alert/index.css'
import { Icon } from "@zebra-fed/zds-react-desktop";
import LinearIndeterminateProgress from '../LinearIndeterminateProgress'
import {SSO_STATUS_CONSTANTS} from '../../data/constants'
import {useTranslation} from "react-i18next";

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px;
    text-align: center;
`

const MessageContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 5px;
    margin-left: 10px;
`
const imgStyle = {
    width: 20,
    height: 20,
    marginTop: 10
}
const imgStyleLoader = {
    width: 30,
    height: 30,
    marginTop: 5,
    marginLeft: "-5px",
    marginRight: "-5px"
}
export default function SSOConfigTestModal(props) {
    const dialogRef = props.modalRef;
    const {t} = useTranslation();
    let progressBar = null;
    if (props.ssoTestStatus === 0) {
        progressBar = (<LinearIndeterminateProgress/>);
    }
    let activateSSOButton = [];
    if (props.ssoTestStatus === 1) {
        activateSSOButton.push(<Item type='button' style={{backgroundColor: '#', width: '102px'}}
                                     onClick={props.onHandleSave}>{t('yes')}</Item>)
        activateSSOButton.push(<Item type='button' style={{backgroundColor: '#', width: '102px'}}
                                     onClick={() => dialogRef.current.toggleDialog()}>{t('no')}</Item>)
    }

    if (props.ssoTestStatus === 2) {
        activateSSOButton.push(<Item type='button' style={{backgroundColor: '#', width: '102px'}}
                                     onClick={() => dialogRef.current.toggleDialog()}>{t('ok')}</Item>)
    }

    return (
        <>
            <Dialog ref={dialogRef}
                    key='dialog2'
                    width='520px'
                    items={activateSSOButton}
                    headerStyle={{display: 'none'}}
                    bodyStyle={{padding: '0px', width: '100%'}}
                    footerStyle={{padding: '24px'}}
                    cardStyle={{marginBottom: '60px'}}
            >
                <ModalHeader>
                    {props.ssoTestStatus === SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED ? t('error') : t('ssoIntegrationTest')}
                </ModalHeader>
                <MainContent>
                    {props.ssoTestStatus === SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED ? (<><Icon 
                        category={'alert'}
                        name={'warning'}
                        color={'#ED1C24'}
                        style={{ paddingBottom: '12px'}}
                        size={80}
                    /></>):null}
                    {props.ssoTestStatus === SSO_STATUS_CONSTANTS.SSOTESTSTATUS.PROGRESS ? (<>{t('ssoIntegrationTestInProgress')}
                        <br/></>) : null}
                    <div>
                        {props.ssoTestStatus < SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED
                        && props.ssoTestStepStatus === SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.AUTHORIZATION ? (<>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/loading.gif'} style={imgStyleLoader} alt={'loading'}/>
                                <MessageContent>{
                                    t('messages.sso.msg1')
                                    /*SSO_CONSTANTS.AUTHORIZATION_VALIDATION_INPROGRESS*/
                                }</MessageContent>
                            </div>
                        </>) : null}
                        {props.ssoTestStatus < SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED
                        && props.ssoTestStepStatus === SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.TOKEN ? (<>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{
                                    t('messages.sso.msg2')
                                    //SSO_CONSTANTS.AUTHORIZATION_VALIDATION_SUCCESS
                                }</MessageContent>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/loading.gif'} style={imgStyleLoader} alt={'loading'}/>
                                <MessageContent>{
                                    t('messages.sso.msg3')
                                    // SSO_CONSTANTS.TOKEN_VALIDATION_INPROGRESS
                                }</MessageContent>
                            </div>
                        </>) : null}
                        {props.ssoTestStatus < SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED
                        && props.ssoTestStepStatus === SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.REVOKE_AND_LOGOUT ? (<>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{
                                    t('messages.sso.msg2')
                                    // SSO_CONSTANTS.AUTHORIZATION_VALIDATION_SUCCESS
                                }</MessageContent>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{
                                    t('messages.sso.msg4')
                                    //SSO_CONSTANTS.TOKEN_VALIDATION_SUCCESS
                                }</MessageContent>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/loading.gif'} style={imgStyleLoader} alt={'loading'}/>
                                <MessageContent>{
                                    t('messages.sso.msg5')
                                    //SSO_CONSTANTS.REVOKE_VALIDATION_INPROGRESS
                                }</MessageContent>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/loading.gif'} style={imgStyleLoader} alt={'loading'}/>
                                <MessageContent>{
                                    t('messages.sso.msg7')
                                    //SSO_CONSTANTS.LOGOUT_VALIDATION_INPROGRESS
                                }</MessageContent>
                            </div>
                        </>) : null}
                        {props.ssoTestStatus < SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED
                        && props.ssoTestStepStatus === SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.ALL_SUCCESS ? (<>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{
                                    t('messages.sso.msg2')
                                    //SSO_CONSTANTS.AUTHORIZATION_VALIDATION_SUCCESS
                                }</MessageContent>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{
                                    t('messages.sso.msg4')
                                    //SSO_CONSTANTS.TOKEN_VALIDATION_SUCCESS
                                }</MessageContent>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{
                                    t('messages.sso.msg6')
                                    //SSO_CONSTANTS.REVOKE_VALIDATION_SUCCESS
                                }</MessageContent>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{
                                    t('messages.sso.msg8')
                                    //SSO_CONSTANTS.LOGOUT_VALIDATION_SUCCESS
                                }</MessageContent>
                            </div>
                        
                        </>) :null }
                        {props.ssoTestStatus === SSO_STATUS_CONSTANTS.SSOTESTSTATUS.SUCCESS && props.ssoTestStepStatus === SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.ALL_SUCCESS ? (<>
                            <div
                            style={{
                                display: "flex",
                            }}
                            >
                                <img src={process.env.PUBLIC_URL + '/green-tick.png'} style={imgStyle} alt={'success-green-tick'}/>
                                <MessageContent>{t('messages.sso.msg13')}</MessageContent>
                            </div>
                        </>) :null }
                    </div>
                    <div style={{paddingTop:20}}>
                        {props.message ? props.message.split('\n').map((str,index) => <React.Fragment key={index} >{str}<br /></React.Fragment>) : null}
                        {progressBar}
                    </div>
                </MainContent>
            </Dialog>
        </>
    )
}
